// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Quiz from "./components/Quiz";

function App() {
  // Define state (no changes here)
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");

  // Keep login state on refresh
  useEffect(() => {
    const savedUser = localStorage.getItem("quizUsername");
    if (savedUser) {
      setIsLoggedIn(true);
      setUsername(savedUser);
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Register Page */}
        <Route path="/register" element={<Register />} />
        
        {/* Login Page */}
        <Route 
          path="/login" 
          element={<Login setIsLoggedIn={setIsLoggedIn} setUsername={setUsername} />} 
        />
        
        {/* Forgot Password Page */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        
        {/* Reset Password Page */}
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Main Quiz Page (FIXED: No inline comments in JSX) */}
        <Route 
          path="/" 
          element={
            isLoggedIn ? (
              <Quiz 
                username={username} 
                setUsername={setUsername}
                setIsLoggedIn={setIsLoggedIn}
              />
            ) : (
              <Login setIsLoggedIn={setIsLoggedIn} setUsername={setUsername} />
            )
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;